import React from "react"
import { Link } from "gatsby"
import { ChevronDown } from "react-feather"
import helpers from "../../styles/helpers.module.css"
import styles from "./header.module.css"

type CMSSubNavProps = {
  name: string
  nameShort: string
  items: Array<itemsType>
  id: number
  title: string
  open: boolean
  page: boolean
  openTrigger: (id: number) => Function
}

type itemsType = {
  id: number
  title: string
  path: string
}

export const CMSSubNav = ({
  name,
  nameShort,
  items,
  id,
  open,
  page,
  openTrigger,
}: CMSSubNavProps) => {
  return (
    <li
      className={`relative ${styles.headerNavigationLinkItem} ${
        page ? `afterBorder` : ``
      }`}
      tabIndex={0}
      key={`navigation-item-${id}`}
      data-testid="subLinkMenu"
      data-cy={`subLinkMenu-${name}`}
      onClick={e => {
        if (open) {
          openTrigger(0)
        } else {
          e.stopPropagation()
          openTrigger(id)
        }
      }}
    >
      {/* This styles Oculoplastic Services, Aesthetic Services and Conditions in Desktop Menu */}
      <span className="flex items-center py-1 font-mono font-medium tracking-wide uppercase text-blackNew">
        {nameShort ? (
          <>
            <span className="xl:hidden font-13">{nameShort}</span>
            <span className="hidden xl:block font-13">{name}</span>
          </>
        ) : (
          <span>{name}</span>
        )}
        <ChevronDown
          className="ml-px transition-transform duration-300"
          style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)" }}
          size="12"
        />
      </span>

      <div
        className={`pointer-events-none absolute top-4 transition-all duration-200 ${
          open ? "opacity-100 translate-y-0 visible" : "opacity-0 -translate-y-2 invisible"
        } ${helpers.cmsContainer}`}
      >
        <div className="px-12 py-10 cursor-default pointer-events-auto border-t-1 border-b-1 border-borderColour bg-white shadow-md">
          <ul
            className="grid grid-flow-col gap-x-6 gap-y-4"
            style={{ gridTemplateRows: `repeat(${Math.ceil(items.length / 3)}, minmax(0, 1fr))`, gridTemplateColumns: "repeat(3, 1fr)" }}
          >
            {items.map(({ id, title, path }) => (
              <li key={`CMSSubNavItem-${title}`}>
                <Link className="capitalize transition-colors duration-150 hover:text-gold600" to={path}>
                  <div className="font-sans text-sm">{title}</div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </li>
  )
}
